export const clientContent = {
    tiny_title: "client_content_tiny_title",
    title: "client_content_title",
    description: "client_content_description"
}